import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';

import { DataService } from '../../data.service';
import { environment } from '../../../environments/environment';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { FormService } from 'src/app/form.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newsleter',
  templateUrl: './newsleter.component.html',
  styleUrls: ['./newsleter.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class NewsleterComponent {

  sending = false;
  collapseInfo = true;

  newsletterForm = new FormGroup({
    email: new FormControl(null, [Validators.required,
      // Validators.pattern(emailRegex)
    ]),
    rulez: new FormControl(false, [Validators.required, Validators.requiredTrue]),
    hairdresser: new FormControl(false),
    manager: new FormControl(false),
  });

  recapcha;

  submitedForm = false;

  constructor(
    private readonly dataService: DataService,
    private readonly formService: FormService,
    private readonly toastSevice: ToastrService,
    private readonly ngxSmartModalService: NgxSmartModalService,
    private readonly reCaptchaV3Service: ReCaptchaV3Service
  ) {

  }

  onSubmit() {
    this.formService.markAsTouched(this.newsletterForm.controls);
    if (this.newsletterForm.valid) {
      this.submitedForm = true;
      this.sending = true;
      const sendData = {
        email: this.newsletterForm.get('email').value,
        hairdresser: this.newsletterForm.get('hairdresser').value ? 1 : 0,
        manager: this.newsletterForm.get('manager').value ? 1 : 0,
      };

      this.reCaptchaV3Service.execute(environment.capchaKey, 'homepage', (token) => {

        const modalData = this.ngxSmartModalService.getTopOpenedModal().getData();

        this.dataService.invoke(`/platform/content-newsletter/${modalData.business ? 'business-salonexpert' : 'salonexpert'}`, 'post', { recaptchaKey: token }, sendData).subscribe(
          res => {
            this.toastSevice.success(`Dziękujemy za zapisanie się do newslettera`);
            this.ngxSmartModalService.close('newsletter');
            this.submitedForm = false;
          },
          err => {
            this.formService.errorResponse(err, this.newsletterForm);
            this.submitedForm = false;
          }
        );
      });
    }
  }
}
